class AdsNinjaAdsInjector {

    configs = {};
    adSetup = null;
    API_params = {};
    validation_errors = [];
    adsData = [];
    customHeaders = {};
    source = null;
    customHeaders = {};

    repeatablePlacementIndex = [];
    repeatableAdCountAdded = [];
    repeatableAdRepeatIndex = [];
    remainingCharacterCount = [];

    characterCountRules = {};

    noRepeatableAdsInsideQueryString = "";
    noRepeatableAdsAfterQueryString = "";

    boostedUrlData = null;
    gamId = null;

    noInjectionRules = {};

    overwrite_changes = [];

    euTraffic = {
        "AT": "Austria",
        "BE": "Belgium",
        "BG": "Bulgaria",
        "HR": "Croatia",
        "CY": "Republic of Cyprus",
        "CZ": "Czech Republic",
        "DK": "Denmark",
        "EE": "Estonia",
        "FI": "Finland",
        "FR": "France",
        "DE": "Germany",
        "GR": "Greece",
        "HU": "Hungary",
        "IS": "Iceland",
        "IE": "Ireland",
        "IT": "Italy",
        "LV": "Latvia",
        "LI": "Liechtenstein",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "MT": "Malta",
        "NL": "Netherlands",
        "NO": "Norway",
        "PL": "Poland",
        "PT": "Portugal",
        "RO": "Romania",
        "SK": "Slovakia",
        "SI": "Slovenia",
        "ES": "Spain",
        "SE": "Sweden",
        "GB": "United Kingdom"
    }; 

    regionsToIncludeCMP = {
        'AT': { 'country': 'Austria',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                                                       
        'BE': { 'country': 'Belgium',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'BG': { 'country': 'Bulgaria',              'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'HR': { 'country': 'Croatia',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'CY': { 'country': 'Republic of Cyprus',    'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                                        
        'CZ': { 'country': 'Czech Republic',        'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                                
        'DK': { 'country': 'Denmark',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'EE': { 'country': 'Estonia',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'FI': { 'country': 'Finland',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'FR': { 'country': 'France',                'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'DE': { 'country': 'Germany',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'GR': { 'country': 'Greece',                'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'HU': { 'country': 'Hungary',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'IS': { 'country': 'Iceland',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'IE': { 'country': 'Ireland',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'IT': { 'country': 'Italy',                 'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                    
        'LV': { 'country': 'Latvia',                'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'LI': { 'country': 'Liechtenstein',         'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                            
        'LT': { 'country': 'Lithuania',             'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'LU': { 'country': 'Luxembourg',            'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                            
        'MT': { 'country': 'Malta',                 'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                    
        'NL': { 'country': 'Netherlands',           'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                            
        'NO': { 'country': 'Norway',                'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'PL': { 'country': 'Poland',                'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'PT': { 'country': 'Portugal',              'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'RO': { 'country': 'Romania',               'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'SK': { 'country': 'Slovakia',              'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'SI': { 'country': 'Slovenia',              'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'ES': { 'country': 'Spain',                 'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                    
        'SE': { 'country': 'Sweden',                'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                        
        'GB': { 'country': 'United Kingdom',        'states': {}, 'consentContext': 'gdpr', 'consentNeeded': true, },                                
        'US': { 
            'country'    : 'United States',         
            'states': {
                'CA': 'California',
                'CO': 'Colorado',
                'CT': 'Connecticut',
                'DE': 'Delaware',
                'FL': 'Florida',
                'IN': 'Indiana',
                'IA': 'Iowa',
                'KY': 'Kentucky',
                'MD': 'Maryland',
                'MT': 'Montana',
                'MN': 'Minnesota',
                'NE': 'Nebraska',
                'NH': 'New Hampshire',
                'NJ': 'New Jersey',
                'OR': 'Oregon',
                'RI': 'Rhode Island',
                'TN': 'Tennessee',
                'TX': 'Texas',
                'UT': 'Utah',
                'VA': 'Virginia'
            },
            'consentContext': 'gpp',
            'consentNeeded' : false,
        },                            
    };

    pageview = 1;

    constructor(configs) {
        this.configs = configs;
    }

    setConfigs = function (configs) {
        this.configs = configs;
    }

    setCountry = function (country) {
        this.country = country;
    }

    setRegion = function (region) {
        this.region = region;
    }

    setCity = function (city) {
        this.city = city;
    }

    setGAMId = function (gamId) {
        this.gamId = gamId;
    }

    setBoostedUrlData = function (isBoosted) {
        
        if(isBoosted){
            this.boostedUrlData = {
                    'isBoosted': isBoosted,
            };
        }

    }

    __getZones = function () {
        return this.configs.zones;
    }

    __getAPIParams = function () {
        return this.API_params;
    }

    init = async function () {
        this.__waitForDOMReady().then(async () => {

            this.pageview = window.adsNinja.storageManager.incrementWithExpiry('pageview', 1200000);

            await this.__setConfigs();
            await this.__setAdSetup();

            this.source = this.__determineSource();

            if (this.adSetup !== null) {

                this.__setNoRepeatableAdsQueryStrings();
                this.__generateAPIParams();
            
                let deviceType = this.__getAPIParams().data['deviceType'];

                if(deviceType){

                    document.body.classList.add(`an-device-${deviceType}`);
                }

                await this.__fetchAdsConfigs();
                await this.__handleOverwriteConfig();
                await this.__handleMappedZones();
                await this.__generateScripts();
                await this.__generatePageLevelTargeting();
                await this.__generateZones();
                this.__initAdsNinja();
            } else {
                console.warn('ADS INJECTOR --- No ads injected');
            }
        })
    }

    __setConfigs = async function () {
        if (typeof this.configs == "string") {
            //consider it as a filename to load the configs
            //get content from the filename if it exists
            await this.__fetchConfigs(this.configs);

        }

        if (!this.__validateConfig()) {
            console.error('Config validation failed');
            if (this.validation_errors) {
                this.validation_errors.forEach(error => console.error(error));
            }
            return;
        }
    }

    __setNoRepeatableAdsQueryStrings = function () {
        let queryString = "";
        let toTest = "";
        if (this.configs["no_repeatable_ads_containers"] !== undefined) {
            this.configs["no_repeatable_ads_containers"].forEach(no_ads => {
                toTest = "";
                switch (no_ads['element_type']) {
                    case 'tag':
                    case 'query':
                        toTest = no_ads['element'];
                        break;
                    case 'class':
                        toTest = '.' + no_ads['element'];
                        break;
                    case 'id':
                        toTest = '#' + no_ads['element'];
                        break;
                }
                if (this.__isQuerySelectorValid(toTest)) {
                    queryString += toTest + ', ';
                } else {
                    console.warn("ADS INJECTOR: no_repeatable_ads_containers selector '" + no_ads['element'] + "' is invalid.");
                }
            });
        }
        this.noRepeatableAdsInsideQueryString = queryString.substring(0, queryString.length - 2);        
        queryString = "";
        if (this.configs["no_repeatable_ads_after"] !== undefined) {
            this.configs["no_repeatable_ads_after"].forEach(no_ads => {
                toTest = "";
                switch (no_ads['element_type']) {
                    case 'tag':
                    case 'query':
                        toTest = no_ads['element'];
                        break;
                    case 'class':
                        toTest = '.' + no_ads['element'];
                        break;
                    case 'id':
                        toTest = '#' + no_ads['element'];
                        break;
                }
                if (this.__isQuerySelectorValid(toTest)) {
                    queryString += toTest + ', ';
                } else {
                    console.warn("ADS INJECTOR: no_repeatable_ads_after selector '" + no_ads['element'] + "' is invalid.");
                }
            });
        }
        this.noRepeatableAdsAfterQueryString = queryString.substring(0, queryString.length - 2);
    }

    __fetchConfigs = async function (path) {
        await fetch(path)
        .then(response => response.json())
        .then(data => {
            this.configs = data;
        })
        .catch(error => {
            console.error('Error reading the JSON file:', error);
        });
    }

    __ajax = async function (url) {
        
        return await fetch(url, {
            method: 'GET',
            timeout: 1000,
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch. Status: ' + response.status);
            }
            return response.json()
        })
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error(error);
        });
        //TODO handle a fail to the api
    }

    __fetchAdsConfigs = async function () {

        var url            = 'adsninja.ca';
        var injectorScript = document.getElementById('an-injector');

        if(injectorScript){
            url = injectorScript.src;
            url = new URL(url);
            url = url.host;
        }

        var version = 'v2';

        if('v1' === version){

            this.adsConfigs = await this.__ajax('https://' + url + '/api/cached/by_adsetup_infos_json/clientData/get/?' + this.__httpBuildQuery(this.__getAPIParams()));
        }
        else{

            this.adsConfigs = await this.__ajax('https://' + url + '/api/cached/' + version + '/by_adsetup_infos_json/clientData/get/?' + this.__httpBuildQuery(this.__getAPIParams()));
        }

        console.log("ADS INJECTOR --- API URL: ", 'https://' + url + '/api/cached/' + version + '/by_adsetup_infos_json/clientData/get/?' + this.__httpBuildQuery(this.__getAPIParams()));
        console.log("ADS INJECTOR --- RECEIVED DATA FROM API: ", this.adsConfigs);
        this.__validateAdsConfigs();
    }

    __handleOverwriteConfig = async function () {
        
        if (!this.configs.overwrite) {
            return;
        }

        //Loops through the overwrite array
        this.configs.overwrite.forEach((overwrite, index) => {
            //Determine if criteria are met
            if (overwrite.hasOwnProperty('criteria')) {
                overwrite.criteria.forEach((criteria) => {
                    console.log('ADS INJECTOR: Overwrite Criteria: ', criteria);
                    
                    //check if day criteria is met
                    if (criteria.days !== undefined) {
                        let days = [];
                        let today = new Date().getDay();
                        console.log('ADS INJECTOR: Day: ', today);
    
                        //handle if its a range format : "start-end"
                        //validation is done in frontend
                        if (typeof criteria.days === 'string') {
                            let explodedDays = criteria.days.split('-');
                            let startDay = explodedDays[0];
                            let endDay = explodedDays[1];
                            days = [];
                            for (let i = parseInt(startDay); i <= endDay; i++) {
                                days.push(i);
                            }
                        } else {
                            days = criteria.days;
                        }
                        
                        console.log('ADS INJECTOR: Days: ', days);
                        if (days.indexOf(today) === -1) {
                            console.log('ADS INJECTOR: Day criteria not met');
                            return;
                        }
    
                    }                
                    
                    //check if hour criteria is met
                    if (criteria.hours !== undefined) {
                        let hours = [];
                        let hour = new Date().getHours();
                        console.log('ADS INJECTOR: Hour : ', hour);
    
                        //handle if its a range format : "start-end"
                        //validation is done in frontend
                        if (typeof criteria.hours === 'string') {
                            let explodedHours = criteria.hours.split('-');
                            let startDay = explodedHours[0];
                            let endDay = explodedHours[1];
                            hours = [];
                            for (let i = parseInt(startDay); i <= endDay; i++) {
                                hours.push(i);
                            }
                        } else {
                            hours = criteria.hours;
                        }
                        console.log('ADS INJECTOR: hours: ', hours);
                        if (hours.indexOf(hour) === -1) {
                            console.log('ADS INJECTOR: Hour criteria not met');
                            return;
                        }
                    }
    
                    //check if url criteria is met
                    let url_passed = true;
                    if (criteria.urls !== undefined) {
                        console.log('ADS INJECTOR: URL: ', window.location.pathname);
                        //how to check if path of the pathname inside the criteria.urls
                        url_passed = false;
                        criteria.urls.forEach((url) => {
                            console.log('ADS INJECTOR: Criteria URL: ', url);
                            if (window.location.pathname.indexOf(url) !== -1) {
                                console.log('ADS INJECTOR: URL criteria met');
                                url_passed = true;
                                return;
                            }
                        })
                    }
    
                    //check if css selector criteria is met
                    let element_passed = true;
                    if (criteria.elements !== undefined) {
                        console.log('ADS INJECTOR: Elements Selectors: ', criteria.elements);
                        //how to check if path of the pathname inside the criteria.urls
                        element_passed = false;
                        criteria.elements.forEach((element) => {
                            console.log('ADS INJECTOR: Criteria CSS Selector: ', element);
                            if (this.__isQuerySelectorValid(element)) {
                                element = document.querySelector(element);
                                console.log('ADS INJECTOR: Element: ', element);
                                if (element !== null) {
                                    console.log('ADS INJECTOR: CSS Selector criteria met');
                                    element_passed = true;
                                    return;
                                }
                            }
                        });
                    }
    
                    //check if dateRange criteria is met
                    let dateRangePassed = true;
                    if (criteria.dateRange !== undefined) {
                        dateRangePassed = false;
                        console.log('ADS INJECTOR: Date Range: ', criteria.dateRange);
                        let now = new Date();
                        let start = new Date(criteria.dateRange.start + ' 00:00:00');
                        let end = new Date(criteria.dateRange.end + ' 00:00:00');
                        console.log('ADS INJECTOR: Now: ', now);
                        console.log('ADS INJECTOR: Start Date: ', start);
                        console.log('ADS INJECTOR: End Date: ', end);
                        if (now >= start && now <= end) {
                            console.log('ADS INJECTOR: Date Range criteria met');
                            dateRangePassed = true;
                        }
                    }
                    console.log ('ADS INJECTOR: Element passed: ', element_passed);
                    console.log ('ADS INJECTOR: URL passed: ', url_passed);
                    console.log ('ADS INJECTOR: Date Range passed: ', dateRangePassed);
                    if (element_passed && url_passed && dateRangePassed) {
                        console.log('ADS INJECTOR: Criteria met changes will be applied', overwrite.changes);
                        //merging overwrite changes
                        this.overwrite_changes = {...this.overwrite_changes, ...overwrite.changes};
                    }
                })
            } else {
                //without criteria all changes will be applied
                console.log('ADS INJECTOR: No criteria. Changes will be applied', overwrite.changes);
                this.overwrite_changes = {...this.overwrite_changes, ...overwrite.changes};
            }
        });

        console.log ('ADS INJECTOR: Overwrite changes: ', this.overwrite_changes);
    }

    __validateAdsConfigs = function () {
        //make sure there is a chosen ad setup
        if (!this.adsConfigs) {
            console.warn('ADS INJECTOR --- No data received from the API');
        } else if (!this.adsConfigs.logData.chosenAdSetup) {
            console.warn('ADS INJECTOR --- API couldn\'t find match a valid ad setup');
            this.adsConfigs = null;
        }
    }

    __generateAPIParams = function (){

        this.API_params = {
            ...this.configs.api_parameters,
            "data": {
                "url" : '/',
                "brandName": this.configs.api_parameters.brandName,
                "modeAds": 1,
                "template": this.adSetup.template,
                "networkCategory": (this.adSetup.networkCategory || "all"),
                "contentType": (this.adSetup.contentType || "all"),
                "deviceType": this.__isMobile() ? "mobile" : "desktop",
                "source": (this.source) ? this.source : null,
                "geo" :(this.country || "all"),
                "extraParams": this.__getExtraParams()
            }
        };
    }

    __getExtraParams = function () {
        let extraParams = {};
        //TODO: add extra params

        //THIS IS VALNET SPECIFIC
        if ( window.isPremiumUser) {
            extraParams = {
                "websiteUserLogin": "premium"
            };
        } else if (window.isUserLoggedIn) {
            extraParams = {
                "websiteUserLogin": "free"
            };
        }
        return extraParams;
    }

    __isMobile = function () {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }

    __getLiveHost = function (host){

        let liveHost = host;

        let urlParts = host.split('.');
        let QAEnvRegex = /^qa\d+$/;

        if (urlParts[0] !== 'www' && (urlParts[0] == 'ads' || QAEnvRegex.test(urlParts[0]))) {
            liveHost = liveHost.replace(urlParts[0], 'www');
        }

        if (urlParts.length > 3) {
            liveHost = liveHost.replace('.' + urlParts[3], '');
        }

        return liveHost;
    }

    __setAdSetup = async function (){

        if(!this?.configs?.ad_setup){

            console.warn('Cannot find template in the config');
            return;
        }

        if(this.configs?.ad_setup?.no_ads.urls){

            let noAds = false;

            Object.entries(this.configs?.ad_setup?.no_ads.urls).every(([key, url]) => {

                if(window.location.href.indexOf(url) !== -1){

                    noAds = true;
                }

                return (!noAds);
            });

            if(noAds){

                this.adSetup = null;

                return;
            }
        }

        if(this.configs?.ad_setup.by_urls){

            Object.entries(this.configs.ad_setup.by_urls).every(([key, setup]) => {

                Object.entries(setup.urls).every(([key, url]) => {

                    if(window.location.href.indexOf(url) !== -1){

                        this.adSetup = setup.setup;
                    }

                    return (!this.adSetup);
                });

                return (!this.adSetup);
            });

            if(this.adSetup){

                return;
            }
        }       
        
        if(this.configs?.ad_setup.by_elements){

            Object.entries(this.configs.ad_setup.by_elements).every(([key, setup]) => {

                Object.entries(setup.elements).every(([key, element]) => {

                    if(this.__isQuerySelectorValid(element.toString())){

                        let query = document.querySelectorAll(element.toString());

                        if(query.length > 0){

                            this.adSetup = setup.setup;
                        }
                    } 
                    else{

                        console.warn('ADS INJECTOR --- Ad Setup by element  "' + element.toString() + '" is invalid.');
                    }

                    return (!this.adSetup);
                });

                return (!this.adSetup);
            });

            if(this.adSetup){

                return;
            }
        }

        var pathname = window.location.pathname;
        pathname     = pathname.replace(/\/$/, '');

        if (['', '/', '/index', '/home', '/index.html', '/home.html', '/index.php', '/home.php', '/index.asp', '/home.asp'].includes(pathname)){

            // You are on the homepage
            this.adSetup = this?.configs?.ad_setup['homepage'];
        } 
        else {

            // You are not on the homepage
            this.adSetup = this?.configs?.ad_setup['default'];
        }
        return;
    }

    __getContainerFromConfigByZoneName = function (zoneName) {
        let container = false;
        this.adSetup?.zones?.forEach(zone => {
            if (zone.name === zoneName) {
                container = zone.container;
                return;
            }
        });
        if (container === false) {
            this.configs?.zones?.forEach(zone => {
                if (zone.name === zoneName) {
                    container = zone.container;
                    return;
                }
            });
        }
        return container;
    }

    __handleMappedZones = async function () {
        if (!this.adsConfigs) {
            return;
        }
        //Check if the zones in the config match the zones in the API
        Object.entries(this.adsConfigs['ads']).forEach(([key, adData]) => {
            let container = this.__getContainerFromConfigByZoneName(adData.zone.name);
            if (container !== false) {
                if (adData.zone.parent === null) { //Dont add children
                    //is set and is not an empty array
                    if (adData.zone.children && adData.zone.children.length > 0) {
                        //set real children
                        adData.zone.realChildren = [];
                        adData.zone.children.forEach(child => {
                            //check if we receive that zone from the api
                            //loops through object ads
                            Object.entries(this.adsConfigs['ads']).forEach(([key, ad]) => {
                                if (ad.zone.name === child.name) {
                                    //set its positionType and displayType
                                    Object.entries(ad.zone.zoneDisplayType).forEach(([key, displayType]) => {
                                        if (adData.idAdsSetup.toString() === key) {
                                            ad.zone.displayType = displayType;
                                        }
                                    })                 
                                    Object.entries(ad.zone.zonePositionType).forEach(([key, positionType]) => {
                                        if (adData.idAdsSetup.toString() === key) {
                                            ad.zone.positionType = positionType;
                                        }
                                    })
                                    adData.zone.realChildren.push(ad);
                                }
                            });
                        });
                    }

                    //add the container from the config for later use
                    adData.container = container;
                    this.adsData.push(adData);
                } else {
                    //throw warning if zone is a child
                    console.warn('ADS INJECTOR --- Child zone shouldn\'t be mapped in the configs. "' + adData.zone.name + '" is a child of "' + adData.zone.parent.name + '"');
                }
            }
            else if(adData.hasOwnProperty('zone') && adData['zone'].hasOwnProperty('isFrontEndInjectable') && adData['zone']['isFrontEndInjectable']){

                this.adsData.push(adData);
            }
            else if(adData.hasOwnProperty('videoOptions') && adData.videoOptions && Object.keys(adData.videoOptions).length > 0){

                this.adsData.push(adData);
            }

            if (!container && adData.zone.parent === null) { //Warn if zone is not mapped in the configs
                console.warn('ADS INJECTOR --- Zone "' + adData.zone.name + '" is not mapped in the configs');
            }
        });
    }

    __generateScripts = async function () {
        
        if (!this.adsConfigs) {
            return;
        }

        let imasdkScript = document.createElement('script');
        imasdkScript.src = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
        imasdkScript.async = false;
        document.head.appendChild(imasdkScript);

        var url            = 'cdn.adsninja.ca';
        var environment    = this.adsConfigs.environment;
        environment        = ('production' === environment.toLowerCase()) ? 'live' : environment;
        var injectorScript = document.getElementById('an-injector');

        if(injectorScript){

            url = injectorScript.src;
            url = new URL(url);
            url = url.host;

            if(url !== 'cdn.adsninja.ca'){

                url += '/cached';
            }
        }

        for (let key in this.adsConfigs.bidderTypeHeaders) {

            let biddertypelibrary   = document.createElement('script');
            biddertypelibrary.src   = 'https://' + url + '/biddertypelibrary/' + environment + '/' + this.adsConfigs.siteConfig.brand['name'] + '/'  + this.adsConfigs.bidderTypeHeaders[key].name + '.js?v=' + this.adsConfigs.jsVersion;
            biddertypelibrary.async = false;
            document.body.append(biddertypelibrary);
            
        }
        
        let mainScript   = document.createElement('script');
        mainScript.src   = 'https://' + url + '/adsninja_client.js?v=' + this.adsConfigs['jsVersion'];
        mainScript.async = false;
        document.body.appendChild(mainScript);


        //loop over the zones and create a script element for each one that match the configs we receive in the constructor
        for (let adTypeHeader_key in this.adsConfigs.adTypeHeaders) {

            let headerScript = this.adsConfigs.adTypeHeaders[adTypeHeader_key].header;
            this.__addContentToHead(headerScript);

            let script = this.adsConfigs.adTypeHeaders[adTypeHeader_key].headerBottom;
            this.__addContentToHead(script);

            let customHeaders = this.adsConfigs.adTypeHeaders[adTypeHeader_key].customHeaders || {};

            //set it here to later use
            this.customHeaders = Object.assign({}, this.customHeaders, customHeaders);

            for (let key in customHeaders) {
                this.__getAdsData().forEach(ad => {

                    if(ad.hasOwnProperty('zone') && ad['zone'].hasOwnProperty('isFrontEndInjectable') && ad['zone']['isFrontEndInjectable']){

                        return true;
                    }
                    else if(('outstream' !== key.toLowerCase() && 'header' !== key.toLowerCase()) && ad.hasOwnProperty('videoOptions') && ad.videoOptions && Object.keys(ad.videoOptions).length > 0){
        
                        return true;
                    }

                    if(key.toLowerCase() === ad.zone.name.toLowerCase()){

                        let element = this.__getZoneElement(ad.container);
                        
                        if (!element && this.adsConfigs.adTypeHeaders[adTypeHeader_key].customHeaders[key].header !== "") { //do it only the element exist
                            return;
                        }
                        let script = this.adsConfigs.adTypeHeaders[adTypeHeader_key].customHeaders[key].header;
                        this.__addContentToHead(script);
                    }    
                });
            }
        }

        let adsninjaStyle = document.createElement('link');
        adsninjaStyle.href = 'https://' + url + '/adsninja_client_style.css?v=' + this.adsConfigs['jsVersion'];
        adsninjaStyle.rel = "stylesheet";
        document.head.appendChild(adsninjaStyle); 

        for (let templateTypeKey in this.adsConfigs.templateTypeDependencies) {
            for (let templateKey in this.adsConfigs.templateTypeDependencies[templateTypeKey]) {
                for (let key in this.adsConfigs.templateTypeDependencies[templateTypeKey][templateKey]) {
                    if (key === "Non-AMP" || (key === "CMP" && this.__shouldIncludeCmp())) {
                        let content = this.adsConfigs.templateTypeDependencies[templateTypeKey][templateKey][key];
                        switch (templateTypeKey) {
                            case 'headers':
                            case 'styles':
                                this.__addContentToHead(content)
                                break;
                            case 'footers':
                                this.__addContentToFooter(content)
                                break;       
                        }
                    } 
                }
            }
        }
    }

    __generatePageLevelTargeting = async function () {
        if (!this.adsConfigs) {
            return;
        }
        
        let isUserLoggedIn = "0";
        if (window.isUserLoggedIn !== undefined && window.isUserLoggedIn) {
            isUserLoggedIn = "1";
        }

        let pageLevelTargeting = `
            <!-- Page-Level Targeting -->          
            <script>
                var googletag = googletag || {};
                googletag.cmd = googletag.cmd || [];
                
                googletag.cmd.push(function() {
                    googletag.pubads()
                    .setTargeting('Site', ['` + this.adsConfigs.siteConfig.brand['name'] + `']) 
                    .setTargeting('ContentType', ['` + (this.adSetup.contentType || "") + `'])
                    .setTargeting('Template', ['` + (this.adSetup.template || "") + `'])
                    .setTargeting('NetworkCategory', ['` + (typeof VALNET_GLOBAL_NETWORKCATEGORY !== 'undefined' ? VALNET_GLOBAL_NETWORKCATEGORY : "") + `'])
                    .setTargeting('SiteCategory', ['` + (this.adSetup.siteCategory || "") + `'])
                    .setTargeting('PostID', ['` + (typeof VALNET_GLOBAL_POSTID !== 'undefined' ? VALNET_GLOBAL_POSTID : "") + `'])
                    .setTargeting('Source', ['` + (this.source || "") + `'])
                    .setTargeting('Intent', ['` + (this.adSetup.intent || "") + `'])
                    .setTargeting('Segment', ['` + (this.adSetup.segment || "") + `'])
                    .setTargeting('LoggedIn', ['` + isUserLoggedIn + `']);            
                 });
            </script>
            <!-- Page-Level Targeting -->
        `;
        

        // High performers GAM key value
        if(this.gamId !== null){

            pageLevelTargeting = pageLevelTargeting +  
            
            `
            <!-- pageUrl identifier -->
            <script>
                googletag.cmd.push(function(){
                   googletag.pubads().setTargeting('pageUrlIdentifier', ['` + this.gamId + `']); 
                });
            </script>
            `;
        }


        // High performers Boosted GAM key value

        if(this.boostedUrlData != null &&typeof this.boostedUrlData === 'object' && Object.keys(this.boostedUrlData).includes('isBoosted') && this.boostedUrlData['isBoosted'] === '1'){


            let boostNow = this.__runABTestboostOnThisPageLoad();
            
            pageLevelTargeting = pageLevelTargeting +  
            
            `
            <!-- pageUrl identifier -->
            <script>
                googletag.cmd.push(function(){
                   googletag.pubads().setTargeting('isBoosted', ['` + boostNow + `']); 
                });
            </script>
            `;
        }

        this.__addContentToHead(pageLevelTargeting);
    }

    // Run AB test to boost an article
    __runABTestboostOnThisPageLoad = function (){

        let boostNow = 0;

        let boostedPercentage = this.__getHighValueAdBehaviourValue('articleBoostPercentage');

        if(boostedPercentage !== null){

            let diceRoll = Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            if(diceRoll <= boostedPercentage){
                
                boostNow = 1;
                this.boostedUrlData['boostNow'] = 1;
                
                
            }else{

                boostNow = 0;
                this.boostedUrlData['boostNow'] = 0;
                
            }

        }

        return boostNow;

    }

        
    // Returns ad behaviour value.
    __getHighValueAdBehaviourValue = function(behaviour){

        if(!Object.keys(this.adsConfigs).includes('adBehaviours') || typeof this.adsConfigs.adBehaviours !== 'object' || this.adsConfigs.adBehaviours == null){

            return null;
        }
        
        let highValueSegmentOptions       = this.adsConfigs.adBehaviours['highValueSegmentOptions'] ?? null;
        let parent                        = this.adsConfigs.adBehaviours['parent'] ?? null;
        let parenthighValueSegmentOptions = parent['highValueSegmentOptions'] ?? null;

        if(highValueSegmentOptions !== null && highValueSegmentOptions[behaviour] !== null){

            return highValueSegmentOptions[behaviour];
        } 
        else if(parenthighValueSegmentOptions !== null && parenthighValueSegmentOptions[behaviour] !== null){

            return parenthighValueSegmentOptions[behaviour];
        }

        return null;
    }

    //
    // Sets the dimensions for an ad.
    __setAdDimensions = function(ad){

        var width  = 'auto';
        var height = 'auto';

        if(ad['customDimensions'] !== null) {

            var dimensions = ad['customDimensions'].split('x');

            if(typeof dimensions[0] !== 'undefined' && dimensions[0] !== ''){

                if (dimensions[0].includes('%')) {

                    width = dimensions[0];
                }
                else{

                    width =`${dimensions[0]}px`;
                }
            }


            if(typeof dimensions[1] !== 'undefined' && dimensions[1] !== ''){

                if(dimensions[1].includes('%')){

                    height = dimensions[1];
                }
                else{

                    height =`${dimensions[1]}px`;
                }
            }
        }
        else if((ad['dimension'] !== null ) && 'no_size' !== ad['dimension']['dimension']){

            var dimensions = ad['dimension']['dimension'].split('x');
            width          = `${dimensions[0]}px`;
            height         = `${dimensions[1]}px`;
        }

        ad['width']  = width;
        ad['height'] = height;

        return ad;
    };

    __generateZones = async function () {
        if (!this.adsConfigs) {
            return;
        }
        
        let newAdsData = []; 
        this.adsData = this.__getAdsData().filter((ad) => {

            ad = this.__setAdDimensions(ad);

            if(ad.hasOwnProperty('zone') && ad['zone'].hasOwnProperty('isFrontEndInjectable') && ad['zone']['isFrontEndInjectable']){

                return true;
            }
            else if(!ad.hasOwnProperty('container') && ad.hasOwnProperty('videoOptions') && ad.videoOptions && Object.keys(ad.videoOptions).length > 0){

                return true;
            }

            if (ad.container?.print === false) {
                //keep it, but don't print a zone
                return true;
            }

            let element = this.__getZoneElement(ad.container);
            if (!element) {
                console.warn('ADS INJECTOR --- Element not found for zone: ' + ad.zone.name + '' );
                return false;
            }

            if(ad.zone.pageLimit 
                && typeof ad.zone.pageLimit === 'object' 
            ){

                switch(ad.zone.pageLimit.idQualifier){

                    case 1:
                        
                        if(this.pageview !== ad.zone.pageLimit.resourceNumber){

                            return false;
                        }    

                        break;
                    
                    case 2:

                        if(this.pageview < ad.zone.pageLimit.resourceNumber){

                            return false;
                        }    

                        break;

                    case 3:

                        if(this.pageview % ad.zone.pageLimit.resourceNumber > 0){

                            return false;
                        }   

                        break; 
                }
            }
            
            if (ad.zone.isRepeatable) { //Repeatable
                let rule = this.adsConfigs.repeatableAdZones[ad.zone.name].repeatableRule;

                if (this.overwrite_changes.hasOwnProperty('startingPoint')) {
                    rule.startingPoint = this.overwrite_changes.startingPoint;
                }              
                if (this.overwrite_changes.hasOwnProperty('degradationStartingPoint')) {
                    rule.degradationStartingPoint = this.overwrite_changes.degradationStartingPoint;
                }                
                if (this.overwrite_changes.hasOwnProperty('degradationStartingPointPlus')) {
                    rule.degradationStartingPointPlus = this.overwrite_changes.degradationStartingPointPlus;
                }

                this.repeatableAdCountAdded[ad.zone.name] = 0;
                this.repeatablePlacementIndex[ad.zone.name] = 0;
                this.repeatableAdRepeatIndex[ad.zone.name] = 0;
                let placement = 'afterend';
                switch (rule.type) {
                    case 'basic': //Every X element ()
                        console.log("ADS INJECTOR --- Repeatable zone :", ad.zone.name);
                        placement = rule.placement == 'before' ? 'beforebegin' : 'afterend';

                        let selector = "";
                        if (rule.htmlTag.toLowerCase() === "custom") {
                            let classNames = rule?.customOpenHtmlTag.match(/class="([^"]+)"/);
                            console.log("ADS INJECTOR --- ClassName :", classNames);
                            if (classNames) {
                                selector = '.' + classNames[1].replace(/\s+/g, ".");
                            } else {
                                console.warn("ADS INJECTOR --- Couldnt find classNames :", selector);
                            }
                        } else {
                            if (rule.htmlTag.toLowerCase() === "image block") {
                                selector = "img";
                            } else {
                                selector = rule.htmlTag.replace("<", "").replace(">", "")
                            }
                        }
                        
                        console.log("ADS INJECTOR --- Selector :", selector);
                        let elements = element.querySelectorAll(selector);
                        console.log("ADS INJECTOR --- Elements :", elements);

                        let every = 1; //always start at every 1
                        for (let i = 0; i < elements.length; i++) {
                            //Do this verification before index incrementation
                            if (this.repeatablePlacementIndex[ad.zone.name] === rule.degradationStartingPoint) {
                                every = rule.degradationEntityCount;
                            }                  
                            if (rule.degradationEntityCountPlus !== null && this.repeatablePlacementIndex[ad.zone.name] === rule.degradationStartingPointPlus) {
                                every = rule.degradationEntityCountPlus;
                            }
                            this.repeatablePlacementIndex[ad.zone.name] += 1;

                            //only add the ad container if its cls friendly or under the viewport
                            if (ad.container?.clsFriendly === undefined || !ad.container?.clsFriendly) {
                                if (this.__isElementWillBeAboveOrInViewport(elements[i], placement)) {
                                    console.warn("ADS INJECTOR --- " + ad.zone.name + " not printed because of CLS verification", elements[i]);
                                    continue;
                                }
                            }

                            if (this.repeatablePlacementIndex[ad.zone.name] === rule.startingPoint) {
                                newAdsData.push(this.__printRepeatableAd(ad, elements[i], rule, placement));
                            } else if ((this.repeatablePlacementIndex[ad.zone.name] - rule.startingPoint) % every === 0) { 
                                newAdsData.push(this.__printRepeatableAd(ad, elements[i], rule, placement));
                            }
                        }
                    break;
                    case 'characterCount':
                        this.remainingCharacterCount[ad.zone.name] = 0;
                        newAdsData = this.__handleCharacterCountRepeatableZone(element, ad, rule, placement, true);
                    break;
                    default: 
                        console.warn('ADS INJECTOR --- Repeatable zone : ' + ad.zone.name + ' has a rule of type  "' + rule.type + '" and is not implemented yet');
                    break;
                }

            } else {

                let placement = "";
                if (ad.container.inside) {
                    if (ad.container.before) {
                        placement = "afterbegin";
                    } else {
                        placement = "beforeend";
                    }
                } else {
                    if (ad.container.before) {
                        placement = "beforebegin";
                    } else {
                        placement = "afterend";
                    }                
                }

                //only add the ad container if its cls friendly or under the viewport
                if (ad.container?.clsFriendly === undefined || !ad.container?.clsFriendly) {
                    if (this.__isElementWillBeAboveOrInViewport(element, placement)) {
                        console.warn("ADS INJECTOR --- " + ad.zone.name + " not printed because of CLS verification", element);
                        return false;
                    }
                }
                let html = this.__generateHtmlByZone(ad.zone.name);

                if(html && this.__possibleToAddAd(element, placement)){
                    element.insertAdjacentHTML(placement, html);
                }
            }
            return true;
        });

        //check if there is any css overwrite changes
        if (this.overwrite_changes.hasOwnProperty('css')) {
            this.overwrite_changes.css.forEach((css) => {
                let elements = document.querySelectorAll(css.selector);
                css.style.forEach((style) => {
                    elements.forEach((element) => {
                        element.style[style.property] = style.value;
                    })
                })
            })
        }

        //add the repeatable adsData
        newAdsData.forEach(newAdData => {
            if (newAdData !== null && newAdData) {
                this.adsData.push(newAdData);
            }
        });
    }

    __handleCharacterCountRepeatableZone(element, ad, rule, placement, injectRepeatableThreshold = false) {
        let newAdsData = [];
        let nodes = this.__getRepeatableCharacterCountNodes(element);
        let limitCharacterCount = rule.characterCount;

        if (this.overwrite_changes.hasOwnProperty('characterCount')) {
            limitCharacterCount = this.overwrite_changes.characterCount;
        }

        if (this.overwrite_changes.hasOwnProperty('degradationCharacterCount')) {
            rule.degradationCharacterCount = this.overwrite_changes.degradationCharacterCount;
        }

        if (this.overwrite_changes.hasOwnProperty('degradationStartingPoint')) {
            rule.degradationStartingPoint = this.overwrite_changes.degradationStartingPoint;
        }

        if (this.overwrite_changes.hasOwnProperty('degradationCharacterCountPlus')) {
            rule.degradationCharacterCountPlus = this.overwrite_changes.degradationCharacterCountPlus;
        }

        if (this.overwrite_changes.hasOwnProperty('degradationStartingPointPlus')) {
            rule.degradationStartingPointPlus = this.overwrite_changes.degradationStartingPointPlus;
        }

        let tryEarlyInjection = false;
        for (let i = 0; i < nodes.length; i++) {
            let nodeCharacterCount = null;
            if (
                rule.degradationCharacterCount !== null &&
                rule.degradationStartingPoint !== null &&
                this.repeatablePlacementIndex[ad.zone.name] >= rule.degradationStartingPoint
            ) {
                limitCharacterCount = rule.degradationCharacterCount;
            }

            if (
                rule.degradationCharacterCountPlus !== null && 
                rule.degradationStartingPointPlus !== null &&
                this.repeatablePlacementIndex[ad.zone.name] >= rule.degradationStartingPointPlus
            ) {
                limitCharacterCount = rule.degradationCharacterCountPlus;
            }

            let identifier = null;

            //Check if the node is an ID
            if (this.characterCountRules.hasOwnProperty('#' + nodes[i].id.toLowerCase())) {
                identifier = '#' + nodes[i].id.toLowerCase();
            }

            //Check if the node is a class
            if (identifier === null) {

                //Verifiy if the brand is FX
                if (this.adsConfigs.siteConfig.brand['shortName'] === 'FX') {
                    //check if multiple classes are present in the character count rules
                    let testMultipleClasses = nodes[i].className.toLowerCase();
                    //strip space end of the string
                    testMultipleClasses = testMultipleClasses.replace(/\s+$/, '');
                    //replace all spaces by .
                    testMultipleClasses = testMultipleClasses.replace(/ /g, ".");
                    testMultipleClasses = '.' + testMultipleClasses;
                    //strip last . if there is one
    
                    if (this.characterCountRules.hasOwnProperty(testMultipleClasses)) {
                        identifier = testMultipleClasses;
                    }
                }
                
                if (identifier === null) {
                    let classNames = nodes[i].className.toLowerCase().split(" ");
                    for (let j = 0; j < classNames.length; j++) {
                        if (this.characterCountRules.hasOwnProperty("." + classNames[j])) {
                            identifier = "." + classNames[j];
                            break;
                        }
                    }
                }
            }

            //Check if the node is a tag
            if (identifier === null) {
                if (this.characterCountRules.hasOwnProperty(nodes[i].nodeName.toLowerCase())) {
                    identifier = nodes[i].nodeName.toLowerCase();
                }
            }

            let debugInfo = {
                nodeCharacterCount: nodeCharacterCount,
                tryEarlyInjection: tryEarlyInjection,
                triedEarlyInjection: false,
                limitCharacterCount: limitCharacterCount,
                remainingCharacterCount: this.remainingCharacterCount[ad.zone.name],
            };

            nodes[i].insertAdjacentHTML('beforebegin', `<!-- Before Debug Info: ${JSON.stringify(debugInfo)}.-->`);

            if (identifier) {
                if (this.characterCountRules[identifier].hasOwnProperty('count')) {
                    nodeCharacterCount = this.characterCountRules[identifier].count;
                } else if (this.characterCountRules[identifier].hasOwnProperty('count_by_child') && this.characterCountRules[identifier].hasOwnProperty('child')) {

                    let multiplier = this.characterCountRules[identifier].count_by_child;
                    let nbChild = nodes[i].querySelectorAll(this.characterCountRules[identifier].child).length;
                    nodeCharacterCount = nbChild * multiplier;
                }
            }

            if (nodeCharacterCount === null) { //if there is no count we will count textContent of the node
                nodeCharacterCount = nodes[i].textContent.replace(/\s+/g, " ").length;
            }
            
            //if we consider early injection
            let missingToReachLimit = limitCharacterCount - this.remainingCharacterCount[ad.zone.name];
            if (tryEarlyInjection) {
                //if we double the missingToReachLimit inject before
                if (missingToReachLimit * 2 <= nodeCharacterCount) {

                    //only add the ad container if its cls friendly or under the viewport
                    if (ad.container?.clsFriendly !== undefined && ad.container?.clsFriendly) {
                        newAdsData.push((this.__printRepeatableAd(ad, nodes[i], rule, 'beforebegin')));
                    } else if (!this.__isElementWillBeAboveOrInViewport(nodes[i], 'beforebegin')) {
                        newAdsData.push(this.__printRepeatableAd(ad, nodes[i], rule, 'beforebegin'));
                    } else {
                        console.warn("ADS INJECTOR --- " + ad.zone.name + " not printed because of CLS verification", nodes[i]);
                    }

                    this.repeatablePlacementIndex[ad.zone.name] += 1;
                    this.remainingCharacterCount[ad.zone.name]  = nodeCharacterCount - missingToReachLimit;
                    tryEarlyInjection                           = false;

                    debugInfo = {
                        nodeCharacterCount: nodeCharacterCount,
                        tryEarlyInjection: tryEarlyInjection,
                        triedEarlyInjection: true,
                        limitCharacterCount: limitCharacterCount,
                        remainingCharacterCount: this.remainingCharacterCount[ad.zone.name],
                    };
                        
                    nodes[i].insertAdjacentHTML('afterend', `<!-- After Debug Info: ${JSON.stringify(debugInfo)}.-->`);
                    continue;
                }
            }

            if ((nodeCharacterCount + this.remainingCharacterCount[ad.zone.name]) > limitCharacterCount) {
                //only add the ad container if its cls friendly or under the viewport
                if (ad.container?.clsFriendly !== undefined && ad.container?.clsFriendly) {
                    newAdsData.push((this.__printRepeatableAd(ad, nodes[i], rule, placement)));
                } else if (!this.__isElementWillBeAboveOrInViewport(nodes[i], placement)) {
                    newAdsData.push(this.__printRepeatableAd(ad, nodes[i], rule, placement));
                } else {
                    console.warn("ADS INJECTOR --- " + ad.zone.name + " not printed because of CLS verification", nodes[i]);
                }
                this.repeatablePlacementIndex[ad.zone.name] += 1;
                this.remainingCharacterCount[ad.zone.name] = 0;
                tryEarlyInjection = false;
            } else {
                this.remainingCharacterCount[ad.zone.name] += nodeCharacterCount;
                //check if we will consider early injection
                tryEarlyInjection = (this.remainingCharacterCount[ad.zone.name] > (limitCharacterCount * 0.65));
            }

            debugInfo = {
                nodeCharacterCount: nodeCharacterCount,
                tryEarlyInjection: tryEarlyInjection,
                triedEarlyInjection: false,
                limitCharacterCount: limitCharacterCount,
                remainingCharacterCount: this.remainingCharacterCount[ad.zone.name],
            };
                
            nodes[i].insertAdjacentHTML('afterend', `<!-- After Debug Info: ${JSON.stringify(debugInfo)}.-->`);
        }

        if (injectRepeatableThreshold) {
            //print if remainingCharactCount is higher than the threshold
            if (ad.container.hasOwnProperty('afterRepeatableThreshold') &&  this.remainingCharacterCount[ad.zone.name] > (limitCharacterCount * ad.container.afterRepeatableThreshold)) {
                //only add the ad container if its cls friendly or under the viewport
                if (ad.container?.clsFriendly !== undefined && ad.container?.clsFriendly) {
                    newAdsData.push(this.__printRepeatableAd(ad, element, rule, 'beforeend'));
                } else if (!this.__isElementWillBeAboveOrInViewport(element, 'beforeend')) {
                    newAdsData.push(this.__printRepeatableAd(ad, element, rule, 'beforeend'));
                } else {
                    console.warn("ADS INJECTOR --- " + ad.zone.name + " not printed because of CLS verification", element);
                }
            }
        }

        return newAdsData;
    }

    //this would be use for dynamic repeatable zones for now.. and figure out later on
    generateRepeatableZones = function (element, zoneName) {
        if (!element) {
            return;
        }
        //trying to find the repeatable zone in the data
        let newAdsData = [];
        let found = false;
        this.__getAdsData().some(ad => {
            if (ad.zone.isRepeatable === false) {
                return false;
            }
            if (ad.zone.name === zoneName && !ad.zone.isFrontEndInjectable) {
                found = true;
                let rule = this.adsConfigs.repeatableAdZones[ad.zone.name].repeatableRule;
                let placement = 'afterend';
                switch (rule.type) {
                    case 'basic': //Every X element ()
                        ///todo
                    break;
                    case 'characterCount': //Every X character count
                        newAdsData = this.__handleCharacterCountRepeatableZone(element, ad, rule, placement, false);
                    break;
                }
            }
            if (found && newAdsData.length > 0) {
                let auctionId = `injector_${Date.now()}`;
                let adsToAuction = [];
                newAdsData.forEach(function(ad){
                    let adUnit = window.adsNinjaHeaderBiddingManager.__createAndAddNewAdData(ad);
                    adUnit.auctionId = auctionId;
                    adsToAuction.push(adUnit);
                });

                var auction = window.adsNinjaHeaderBiddingManager.setupAuctionRepeatable(adsToAuction, auctionId);
                
                if(!auction){
                    return false;
                }
                
                window.adsNinjaHeaderBiddingManager.setupDynamicallyInjectionRefreshAdZones(auction.getGamAdSlots(), window.adsNinjaHeaderBiddingManager.__refreshData);
                window.adsNinjaHeaderBiddingManager.requestHeaderBids(auction.getId());
                window.adsNinjaHeaderBiddingManager.startFailSafeTimeout(auction.getId());

                return true;
            }
        });

        return newAdsData;
    }

    __isElementWillBeAboveOrInViewport = function (element, placement) {
        let rect = element.getBoundingClientRect();

        switch (placement) {
            case 'beforebegin': //before the element
            case 'afterbegin': //inside at the start of the element
                return((rect.top <= window.innerHeight && rect.bottom >= 0) || rect.top < 0);
            case 'beforeend': //inside but at the end of the element
            case 'afterend': //after the element
                return((rect.bottom <= window.innerHeight));
        }
    }

    __getRepeatableCharacterCountNodes = function (element) {
        this.characterCountRules = {};
        let identifiers = [];
        if (this.configs['character_count_rules']) {
            this.configs['character_count_rules'].forEach(config => {
                if (config.identifier && this.__isQuerySelectorValid(config.identifier)) {
                    let identifier = config.identifier.toLowerCase();
                    document.querySelector(identifier);
                    this.characterCountRules[identifier] = config;
                    identifiers.push(identifier);
                } else {
                    console.warn('ADS INJECTOR --- character_count_rules "' + config.identifier + '" is not a valid identifier');
                }
            });
            if (identifiers.length > 0) {
                let nodes = [];

                element.querySelectorAll(identifiers.join(', ')).forEach(node => {
                    let parentFound = false;
                    //verification if this identifier is a child of another identifier.
                    identifiers.forEach(identifier => {
                      if (this.__hasParent(node, identifier)) {
                        parentFound = true;
                        return;
                      }
                    });
                    //if not we use it
                    if (!parentFound) {
                        nodes.push(node);
                        return;
                    }
                });
                return nodes;
            }
        }
        return false;
    }

    __hasParent(element, parentSelector) {
        if (element.parentElement === null) {
          return false;
        }
        if (element.parentElement.matches(parentSelector)) {
          return true;
        }
        return this.__hasParent(element.parentElement, parentSelector);
    }

    __isQuerySelectorValid = function (selector) {
        try {
            document.querySelector(selector);
            return true;
        } catch (e) {
            return false;
        }
    }
    __getNextRepeatableAd = function (parent) {
        if (!parent.zone|| !parent.zone.realChildren) {
            return parent;
        }

        //We start by trying to use "at"
        let adToUse = null;
        //TODO we use the same count, but it should by adSlot
        parent.zone.realChildren.forEach(realChild => {
            if (realChild.zone.positionType === 1) {
                if (realChild.zone.position === this.repeatableAdCountAdded[parent.zone.name]) {
                    adToUse = realChild;
                    return;
                }
            }
        });

        if (adToUse === null) {
            //We start by trying to use "every"
            parent.zone.realChildren.forEach(realChild => {
                if (realChild.zone.positionType === 2) {
                    if ((this.repeatableAdCountAdded[parent.zone.name] % realChild.zone.position) === 0) {
                        adToUse = realChild;
                        return;
                    }
                }
            });
        }

        if (adToUse === null) { //Use the default
            adToUse = parent;
        }
        return adToUse;
    }

    __possibleToAddAd = function(node, placement) {

        if (!this.configs['no_injection_rules']) {
            return true;
        }

        let rules = [];
        let adjacentNode = null;
        let adjacentRules = [];
        //check if we are trying to inject inside the node
        if (placement == 'afterbegin' || placement == 'beforeend') {
            if (this.configs['no_injection_rules'].inside) {
                rules = this.configs['no_injection_rules'].inside;
            }
        } else {
            if (placement == 'beforebegin') {
                if (this.configs['no_injection_rules'].before) {
                    rules = this.configs['no_injection_rules'].before;
                }
                if (this.configs['no_injection_rules'].after) {
                    adjacentRules = this.configs['no_injection_rules'].after;
                    //find previous sibling that is not a html comment
                    adjacentNode = node.previousSibling;
                    if (adjacentNode !== null) {
                        while (adjacentNode.nodeType == Node.COMMENT_NODE || adjacentNode.nodeType == Node.TEXT_NODE) {
                            adjacentNode = adjacentNode.previousSibling;
                            if (adjacentNode === null) {
                                break;
                            }
                        }
                    }
                }
            } else if (placement == 'afterend') {
                if (this.configs['no_injection_rules'].after) {
                    rules = this.configs['no_injection_rules'].after;
                }
                if (this.configs['no_injection_rules'].before) {
                    adjacentRules = this.configs['no_injection_rules'].before;
                    //find next sibling that is not a html comment
                    adjacentNode = node.nextSibling;    
                    if (adjacentNode !== null) {
                        while (adjacentNode.nodeType == Node.COMMENT_NODE || adjacentNode.nodeType == Node.TEXT_NODE) {
                            adjacentNode = adjacentNode.nextSibling;
                            if (adjacentNode === null) {
                                break;
                            }
                        }
                    }
                }
            }
        }

        let isPossible = true;
        rules.forEach(rule => {
            if (this.__isQuerySelectorValid(rule)) {
                let ruleNodes = document.querySelectorAll(rule);
                ruleNodes.forEach(ruleNode => {
                    if (ruleNode === node) {
                        console.log('No injection rule '  + placement + ' : ' + rule, node);
                        isPossible = false;
                    }
                })
            }
        });

        //check if adjacent node is possible
        if (adjacentNode !== null && isPossible) {
            adjacentRules.forEach(rule => {
                if (this.__isQuerySelectorValid(rule)) {
                    let ruleNodes = document.querySelectorAll(rule);
                    ruleNodes.forEach(ruleNode => {
                        if (ruleNode === adjacentNode) {
                            console.log('No injection rule '  + placement + ' : ' + rule, node);
                            isPossible = false;
                        }
                    })
                }
            });
        }

        if (isPossible) {
            //check if its inside a rule
            if (this.configs['no_injection_rules'].inside) {
                this.configs['no_injection_rules'].inside.forEach(rule => {
                    //check parents
                    if (this.__hasParent(node, rule)) {
                        console.log('No injection rule '  + placement + ' : ' + rule, node);
                        isPossible = false;
                        return false;
                    }
                });
            }
        }

        return isPossible;
    }

    __printRepeatableAd = function(ad, node, rule, placement) {
        let afterVerification = (!placement.includes("before"));
        let printableNode = this.__getPrintableNode(node, afterVerification);

        if (printableNode === null) {
            return null;
        }

        if (!this.__possibleToAddAd(printableNode, placement)) {
            return null;
        }

        let verificationNode = null;
        if (afterVerification) {
            verificationNode = printableNode.nextElementSibling;
        } else {
            verificationNode = printableNode.previousElementSibling;
        }

        //Only print if the node is not already injected in the same placement
        if (verificationNode && verificationNode.classList.contains("an-injector-zone")) {
            return null;
        }

        //Only print if the node is not already injected in the same placement
        if (!printableNode.classList.contains("adsninja-injected-repeatable-ad-"+placement)) {

            if (this.overwrite_changes.hasOwnProperty('startingPoint')) {
                rule.startingPoint = this.overwrite_changes.startingPoint;
            }
            if (this.overwrite_changes.hasOwnProperty('skipEvery')) {
                rule.skipEvery = this.overwrite_changes.skipEvery;
            }            
            if (this.overwrite_changes.hasOwnProperty('stopAds')) {
                rule.stopAds = this.overwrite_changes.stopAds;
            }

            if (this.repeatablePlacementIndex[ad.zone.name] >= rule.startingPoint) {
                this.repeatableAdCountAdded[ad.zone.name] += 1;
    
                if (
                    (rule.skipEvery !== null && this.repeatableAdCountAdded[ad.zone.name] % (rule.skipEvery+1) === 0) || //skip every n ads
                    (rule.stopAds !== null && this.repeatableAdCountAdded[ad.zone.name] >= (rule.stopAds + 1)) //stop after n ads
                ) {
                    return;
                }
    
                let adToUse = this.__getNextRepeatableAd(ad);
                if (!adToUse) {
                    return;
                }
    
                let html = this.__generateHtmlByZone(adToUse.zone.name);

                if(!html){
                    
                    return;
                }

                let headerScript = this.__getZoneHeaders(adToUse.zone.name);

                let newAdElementId = adToUse.divId;

                let headerScriptElement = document.createElement('script');

                if (typeof this.repeatableAdRepeatIndex[adToUse.zone.name] === 'undefined') {
                    this.repeatableAdRepeatIndex[adToUse.zone.name] = 0;
                }

                if (adToUse.zone.positionType !== 1) {
                    if (this.repeatableAdRepeatIndex[adToUse.zone.name] !== 0) {
                        newAdElementId = adToUse.divId + "-REPEAT" + this.repeatableAdRepeatIndex[adToUse.zone.name];
                        headerScriptElement.innerHTML = headerScript.replace(new RegExp(adToUse.divId, 'g'), newAdElementId);
                        html = html.replace(new RegExp(adToUse.divId, 'g'), newAdElementId);
                        document.head.appendChild(headerScriptElement);
                    }
                    this.repeatableAdRepeatIndex[adToUse.zone.name]++;
                } else {
                    headerScriptElement.innerHTML = headerScript;
                    document.head.appendChild(headerScriptElement);
                }
                //transform that html to a node
                let temp = document.createElement('div');
                temp.innerHTML = html;
                
                //extract the script from the html
                let extractedScript = temp.querySelector('script');
                let newAdElement = temp.querySelector('#' + newAdElementId);
                newAdElement.innerHTML = "";

                var yTop               = null;
                var yBottom            = null;
                var xLeft              = null;
                var xRight             = null;
                var boundingClientRect = printableNode.getBoundingClientRect();
                var adHeight           = ad.height || null;
                adHeight               = (adHeight.includes('px')) ? parseFloat(adHeight.replace('px', '')) : 0;
                var top                = boundingClientRect.top + window.scrollY;
                var bottom             = boundingClientRect.bottom + window.scrollY;

                switch(placement){

                    case 'beforebegin':

                        yTop    = top - adHeight;
                        yBottom = top;
                        xLeft   = boundingClientRect.left;
                        xRight  = boundingClientRect.right;

                        break;

                    case 'beforeend':

                        yTop    = bottom  - adHeight;
                        yBottom = bottom;
                        xLeft   = boundingClientRect.left;
                        xRight  = boundingClientRect.right;

                        break;

                    case 'afterbegin':

                        yTop    = top;
                        yBottom = top + adHeight;
                        xLeft   = boundingClientRect.left;
                        xRight  = boundingClientRect.right;

                        break;

                    case 'afterend':

                        yTop    = bottom;
                        yBottom = bottom + adHeight;
                        xLeft   = boundingClientRect.left;
                        xRight  = boundingClientRect.right;

                        break;
                }

                var content = `
                    <div class="an-injected" data-estimated-y-top="${yTop}" data-estimated-y-bottom="${yBottom}" data-estimated-x-left="${xLeft}" data-estimated-x-right="${xRight}">
                        ${temp.innerHTML}
                    </div>
                `;

                printableNode.insertAdjacentHTML(placement, content);

                if (extractedScript) {
                    //add the script so it's executed
                    let scriptElement = document.createElement('script');
                    scriptElement.innerHTML = extractedScript.innerHTML;
                    newAdElement = document.getElementById(newAdElementId);
                    if (newAdElement) {
                        newAdElement.appendChild(scriptElement);
                    }
                }

                //add class so we don't reinject at the same position
                printableNode.classList.add("adsninja-injected-repeatable-ad-"+placement);
    
                //Copy Ad Data and add it to the adsData to send it to adsNinja.run
                let newAdData = {...adToUse};
                if (adToUse.zone.positionType !== 1) {
                    newAdData.divId = newAdElementId;
                }
                return newAdData;
            }
        }
        return null;
    };

    __getPrintableNode = function (node, afterVerification) {
        node = this.__getPrintableNodeCheckingParentsExceptions(node);
        node = this.__getPrintableNodeCheckingAfterExceptions(node, afterVerification);
        return node;
    }

    __getPrintableNodeCheckingParentsExceptions = function (node) {
        let testingNode = node;
        if (this.noRepeatableAdsInsideQueryString !== "") {
            //check parent
            while (testingNode.parentNode && testingNode.parentNode.nodeName !== '#document') { 
                if (testingNode.parentNode.matches(this.noRepeatableAdsInsideQueryString)) {
                    return this.__getPrintableNodeCheckingParentsExceptions(testingNode.parentNode); //return the parent
                }
                testingNode = testingNode.parentNode;
            }

        }
        return node;
    }

    __getPrintableNodeCheckingAfterExceptions = function (node, afterVerification) {
        let testingNode = node;
        if (testingNode === null) {
            return null;
        }
        //check previous
        if (this.noRepeatableAdsAfterQueryString !== "") {
            if (afterVerification) { //we check if the current node can be 
                if (testingNode.matches(this.noRepeatableAdsAfterQueryString)) {
                    return this.__getPrintableNodeCheckingAfterExceptions(testingNode.previousElementSibling, afterVerification);
                }
            } else if (testingNode.previousElementSibling) {
                if (testingNode.previousElementSibling.matches(this.noRepeatableAdsAfterQueryString)) {
                    return this.__getPrintableNodeCheckingAfterExceptions(testingNode.previousElementSibling, afterVerification);
                }
            }
        }
        return testingNode;
    }

    __getZoneElement = function (container) {
        if (!container || !container.type || !container.identifier) {
            return;
        }
        let element = null;
        switch (container.type) {
            default:
            case 'query':
                if (this.__isQuerySelectorValid(container.identifier)) {
                    element = document.querySelector(container.identifier);
                } else {
                    console.warn('ADS INJECTOR: Invalid zone container identifier : ' + container.identifier);
                }
                //TODO check if there is none
                break;
            case 'class':
                //always take the first for now
                try {
                    element = document.getElementsByClassName(container.identifier)[0];
                    
                } catch (error) {
                    console.warn('ADS INJECTOR: Invalid zone container identifier : ' + container.identifier);
                }
                if (container.first) {
                    // element = document.getElementsByClassName(container.identifier)[0];
                    //TODO check if there is none
                } else {
                    //TODO handle when there are more than one
                }
                break;            
            case 'tag':
                //always take the first for now
                try {
                    element = document.getElementsByTagName(container.identifier)[0];
                    
                } catch (error) {
                    console.warn('ADS INJECTOR: Invalid zone container identifier : ' + container.identifier);
                }
                if (container.first) {
                    //TODO check if there is none
                    // element = document.getElementsByTagName(container.identifier)[0];
                } else {
                    //TODO handle when there are more than one
                }
                break;            
            case 'id':   
                try {
                    element = document.getElementById(container.identifier);
                } catch (error) {
                    console.warn('ADS INJECTOR: Invalid zone container identifier : ' + container.identifier);
                }
                //TODO check if there is none
                break;
        }

        return element;
    }

    __getZoneHeaders = function (zoneName) {
        let customHeader = this.customHeaders[zoneName] || null;

        if(!customHeader){
         
            return '';
        }

        let script = customHeader.header.replace(/<script>/g, "");
        script =script.replace(/<\/script>/g, "");

        return script
    }

    __generateHtmlByZone = function (zoneName) {
        let ad = this.adsConfigs.adContentPerZone[zoneName] || null;

        if (!ad) {
            return;
        }

        let style = "";
        let additionalClasses = ad.additionalClasses || "";

        additionalClasses += ' an-injector-zone ';

        if (ad.isValstreamVideo) {
            additionalClasses += " adsninja-valstream an-zone-vp ";
        } else {
            additionalClasses += " an-zone-d ";
        }

        if (ad.doNotUseSpace) {
            let floatingPriority = ad.floatingPriority || 2147482647;
            additionalClasses += " adsninja-ad-zone-not-using-space ";
            style += "height: 0; border: none; padding: 0; margin: 0; position: fixed; bottom: 0px; z-index: " + floatingPriority;
        }
        if (ad.adElementId.includes("connectedBelowAd") || ad.isConnectedBelowAd) {
            additionalClasses += " connectedBelowAd ";
        }

        if (ad.useinterscrollerAnimation) {
            additionalClasses += " interscroller-wrapper ";
        }

        if (additionalClasses.includes("an-can-float") && !ad.isValstreamVideo) {
            additionalClasses += " an-constrained ";
        }

        let disableHideAdsButton = this.configs.disable_remove_ads_button ?? false;

        let hideAdsLink = this.configs.remove_ads_url ?? `/premium/?ref=ad_removal`;
        let hideAdsButton = ``;

        let showHideAdsButton = !disableHideAdsButton && 
                                !ad.hasFloatingOptions && 
                                !ad.hasVideoOptions && 
                                !ad.isValstreamVideo && 
                                ('footer' !== ad['zoneGroupName'] || 'footer' === ad['zoneGroupName'] && 'footer' === ad['zoneName']) &&
                                'header' !== ad['zoneGroupName'];

        if (showHideAdsButton) {  
            hideAdsButton = `<a class='an-btn an-btn-hide-me' target='_blank' href='${hideAdsLink}' style='visibility: hidden'><span class='an-btn-icon an-btn-icon-close'>&#x2715</span> Remove Ads</a>`;
        } 

        // TODO: Make configurable, this is for no-fill hidding zones.
        // if(this.__isMobile() && 'content' === ad['zoneGroupName'] && !ad.hasVideoOptions && (location.hostname.indexOf('thesportster.com') !== -1)){
            
        //     additionalClasses += " an-hidden ";
        // }

        let dataAttributesString = '';

        if(ad.hasOwnProperty('dataAttributes') && ad.dataAttributes){

            for(let key in ad.dataAttributes){

                dataAttributesString += `data-${key}=\"${ad.dataAttributes[key]}\" `;
            }
        }
        
        return '<!-- Zone: "' + zoneName + '" --><div class="adsninja-ad-zone an-zone ' + additionalClasses + ad.useStickySlideAnimation + '" id="adsninja-ad-zone-' + ad.adElementId + '" style="' + style + '" ' + dataAttributesString + '> ' + hideAdsButton + ad.content + '</div>';
    }

    __validateConfig = function () {
        this.validation = true;
        if (!this.configs) {
            this.validation =  false;
            this.validation_errors.push("Configurations are missing");
            return;
        }        
        
        if (!this.configs.api_parameters) {
            this.validation =  false;
            this.validation_errors.push("Api parameters are missing");
            return;
        } 
        
        if (!this.configs.ad_setup) {
            this.validation =  false;
            this.validation_errors.push("Configurations are missing ad setup");
            return;
        }        
        
        if (!this.configs.ad_setup.homepage) {
            this.validation =  false;
            this.validation_errors.push("Homepage ad setup config is missing");
            return;
        }      
        
        if (!this.configs.ad_setup.default) {
            this.validation =  false;
            this.validation_errors.push("Default ad setup config is missing");
            return;
        }

        if (!this.configs.zones) {
            this.validation =  false;
            this.validation_errors.push("Configurations are missing zones");
            return;
        }        
        
        this.__validateZones();
        return this.validation;
    }

    __initAdsNinja = function () {
        if (!this.adsConfigs) {
            return;
        }

        document.body.classList.add('an-injector-site');

        window.brandName = this.adsConfigs.siteConfig.brand['shortName'];

        if (this.adsConfigs.logData.hasOwnProperty('winningAdUnitId')) {
            this.adsConfigs['logData']['winningAdUnitIds'] = this.adsConfigs['logData']['winningAdUnitId'];
            delete this.adsConfigs.logData.winningAdUnitId;
        }

        if (this.adsConfigs.logData.clientData.hasOwnProperty('networkCategory')) {
            this.adsConfigs.logData.clientData['networkCategory'] = (typeof VALNET_GLOBAL_NETWORKCATEGORY !== 'undefined' ? VALNET_GLOBAL_NETWORKCATEGORY : "all")
        }

        var logData = this.adsConfigs['logData'] || {};

        if(logData && logData.hasOwnProperty('clientData')){
            logData.clientData['url'] =  window.location.protocol + '//' + window.location.hostname + '/' + window.location.pathname.replace(/(^\/+|\/+$)/g, '') + '/';
            if (window.location.pathname === '/') {
                logData.clientData['url'] =  window.location.protocol + '//' + window.location.hostname + '/';
            }
            if (window.brandName === 'FX' || window.brandName === 'POLY') {
                logData.clientData['url'] =  window.location.protocol + '//' + window.location.hostname +  window.location.pathname
            }
        }
        
        let data = {
            'siteConfig' :  this.adsConfigs.siteConfig ? this.adsConfigs.siteConfig : null,
            'failSafeTimeout' : this.adsConfigs.siteConfig['globFailSafeTimeout'] ?? this.adsConfigs.siteConfig['globalFailSafeTimeout'] ?? this.adsConfigs.siteConfig['failSafeTimeout']  ?? 3500,
            'cmpTimeout' : this.adsConfigs.siteConfig['cmpTimeout'] ?? 4000,
            'prebidTimeout' : this.adsConfigs.siteConfig['prebidTimeout'] ?? 3000,
            'amazonTimeout' : this.adsConfigs.siteConfig['amazonTimeout'] ?? 3000,
            'isEuTraffic' : this.__isEuTraffic(),
            // 'usingVideoPlayer' : this.adsConfigs['usingVideoPlayer'],
            'usingVideoPlayer' : true, //also always set to true in adsNinjaClient
            'prebidServerAliasData' : this.adsConfigs['prebidServerAliasData'],
            'adCapabilities' : this.adsConfigs['adCapabilities'], 
            'adsData' : this.__getAdsData(), //in adsNinjaClient we remove a bunch of data
            'railAds' : [],
            'modeAds' : 1, //TODO Hardcoded for now -> do we want different
            'deviceType' : this.__getAPIParams().data['deviceType'],
            'adCountData' : {
                "articleNumber" : 0,
                "injectionTypeCounts": [],
                "pageNumber": 0,
            }, // TODO
            'allowedDomains' : this.__getAllowedDomains(),
            'videoList' : this.adsConfigs['videoList'],
            'logData' : this.adsConfigs['logData'],
            'dynamicallyInjectedAdZones' : [], //TODO
            'dynamicInjectionRefreshAdZones' : this.__getDynamicInjectionRefreshAdZones(), 
            'adUnitBidderConfigs' : this.adsConfigs['adUnitBidderConfigsPrebid'], // in adsNinjaClient we remove a bunch of data
            'sspsThatCouldHaveOwnCloseButton' : this.adsConfigs['sspsThatCouldHaveOwnCloseButton'],
            'eventTrackingDictionary' : this.adsConfigs['eventTrackingDictionary'],
            'adBehaviours' : this.adsConfigs['adBehaviours'],
            'pageLevelDefinition' : this.adsConfigs['pageLevelDefinition'] || {},
            'consentContext' : this.__getConsentContext(),
            'consentNeeded' : this.__getConsentNeeded(),
            'connectionConfig' : this.adsConfigs['connectionConfig'],
            'boostedUrlData' : this.boostedUrlData,
            'pageGamId': this.gamId,
            'floors' : this.adsConfigs['floors'] || null,
            'directDealsMapping' : (typeof this.adsConfigs['directDealsMapping'] === 'object' && Object.keys(this.adsConfigs['directDealsMapping']).length !== 0) ? this.adsConfigs['directDealsMapping'] : {},
            'apiVersion' : this.adsConfigs['apiVersion'] || 'v1',
            'injectionConfig' : this.configs,
        };

        console.log("ADS INJECTOR --- DATA SENT TO ADSNINJA CLIENT", data);

        var an_sentinelEnabled    = null;
        var an_sentinelSiteConfig = (this.adsConfigs.siteConfig) ? this.adsConfigs.siteConfig : null
        
        if(an_sentinelSiteConfig !== null){

            an_sentinelEnabled = an_sentinelSiteConfig['sentinelEnabled'] ?? false;
        }

        // Default page level definition if empty.
        if(!data.pageLevelDefinition || (typeof data.pageLevelDefinition === 'object' && Object.keys(data.pageLevelDefinition).length === 0)){

            data.pageLevelDefinition.engagementContainer = 'body';
        }

        var an_sentinelData = {
            'an_sn_e': an_sentinelEnabled,
            'mode_A': 1,                                                    // TODO Hardcoded for now -> do we want different?
            'pageLevelDefinition': window.pageLevelDefinitionObj || data.pageLevelDefinition,
            'infiniteScrollEvent': 'adsNinjaSentinelInfiniteScroll',        // TODO Hardcoded for now -> do we want different?
        };

        window.an_sn       = window.an_sn || {};
        window.an_sn.queue = window.an_sn.queue || [];
    
        window.an_sn.queue.unshift(function(){
            
            window.an_sn.init(an_sentinelData, 'init');
        });

        window.adsNinja                    = window.adsNinja || {};
        window.adsNinja.queue              = window.adsNinja.queue || [];
        window.adsNinja.isInjectorInjected = true;
        
        window.adsNinja.queue.unshift(function(){

            window.adsNinja.run(data);
        });

        //keep it here for now
        let toIgnore = [];
        this.adsConfigs['splitMarkersForIgnoreBlock'].forEach(rule => {
            let classRegex = /class\s*=\s*["']?([^"'\s>]*)([^"'\s>]*)/i;
            let classMatch = classRegex.exec(rule.opener);
            if (classMatch) {
                toIgnore.push(classMatch[1].split(/\s+/));
            }                 
            let idRegex = /id\s*=\s*["']?([^"'\s>]*)([^"'\s>]*)/i;
            let idMatch = idRegex.exec(rule.opener);
            if (idMatch) {
                toIgnore.push(idMatch[1].split(/\s+/));
            }
        });

        window.toIgnore = toIgnore;
        var self        = this;

        var readyStateCompleteCallback = function(){

            window.adsNinja.queue.push(function(){

                window.adsNinja.queue.push(function(){
    
                    var querySelector = '';
    
                    var rails = [];
                    if(self.configs 
                        && self.configs.hasOwnProperty('secondary') 
                        && self.configs['secondary'] 
                        && self.configs['secondary'].hasOwnProperty('rail') 
                        && self.configs['secondary']['rail'] 
                        && Array.isArray(self.configs['secondary']['rail'])
                    ){
                        self.configs['secondary']['rail'].forEach(function(rail){
                            if (self.__isQuerySelectorValid(rail)) {
                                rails.push(rail);
                            } else {
                                console.warn('ADS INJECTOR: Invalid secondary rail identifier : ' + rail);
                            }
                        });
    
                        if (rails.length > 0) {
                            querySelector = rails.join(', ');
                        } else {
                            return;
                        }
                    }
                    else{
    
                        return;
                    }
                    var rails = document.querySelectorAll(querySelector);
                    
                    rails.forEach(function(rail){
                        
                        window.adsNinja.monetizeRail(
                            rail, 
                            {
                                name: 'rail',
                                groupName: 'sidebar',
                            },
                            {
                                ignore: window.toIgnore,
                                backupZoneInfo: {
                                    name: 'rail short',
                                    groupName: 'sidebar',
                                },
                            }
                        );
                    });
                });
    
                window.adsNinja.queue.push(function(){
    
                    var querySelector = '';
    
                    if(self.configs 
                        && self.configs.hasOwnProperty('secondary') 
                        && self.configs['secondary'] 
                        && self.configs['secondary'].hasOwnProperty('table') 
                        && self.configs['secondary']['table'] 
                        && Array.isArray(self.configs['secondary']['table'])
                    ){
    
                        querySelector = self.configs['secondary']['table'].join(', ');
                    }
                    else{
    
                        querySelector = `#article-body > div.content-block-regular > div.table-container > table`;
                        querySelector += `, #article-body > div.content-block-regular > #article-hidden-content > div.table-container > table`;
                    }
    
                    var tables = document.querySelectorAll(querySelector);
                    
                    tables.forEach(function(table){
                        
                        window.adsNinja.monetizeTable(
                            table, 
                            {
                                name: 'character count repeatable secondary',
                                groupName: 'content',
                            },
                            {
                                ignore: window.toIgnore
                            }
                        );
                    });
                });
            
                window.adsNinja.queue.push(function(){
    
                    var querySelector = '';
    
                    if(self.configs 
                        && self.configs.hasOwnProperty('secondary') 
                        && self.configs['secondary'] 
                        && self.configs['secondary'].hasOwnProperty('list') 
                        && self.configs['secondary']['list'] 
                        && Array.isArray(self.configs['secondary']['list'])
                    ){
    
                        querySelector = self.configs['secondary']['list'].join(', ');
                    }
                    else{
    
                        querySelector = `#article-body > div.content-block-regular > ul`;
                        querySelector += `, #article-body > div.content-block-regular > ol`;
                        querySelector += `, #article-body > div.content-block-regular > div.directory-container > ul`;
                        querySelector += `, #article-body > div.content-block-regular > div.directory-container > ol`;
                        querySelector += `, #article-body > div.content-block-regular > #article-hidden-content > ul`;
                        querySelector += `, #article-body > div.content-block-regular > #article-hidden-content > ol`;
                        querySelector += `, #article-body > div.content-block-regular > #article-hidden-content > div.directory-container > ul`;
                        querySelector += `, #article-body > div.content-block-regular > #article-hidden-content > div.directory-container > ol`;
                    }
    
                    var lists = document.querySelectorAll(querySelector);
            
                    lists.forEach(function(list){
                        
                        window.adsNinja.monetizeList(
                            list, 
                            {
                                name: 'character count repeatable secondary',
                                groupName: 'content',
                            },
                            {
                                ignore: window.toIgnore
                            }
                        );
                    });
                });
            });
        };

        if('complete' !== document.readyState){
        
            document.addEventListener('readystatechange', function(event){
                
                if('complete' === event.target.readyState){
        
                    readyStateCompleteCallback();
                }
            });
        }
        else{
        
            readyStateCompleteCallback();
        }
    }
    
    __validateZones = function () {
        this.__getZones().forEach(zone => {
            if (!zone.name) {
                this.validation = false;
                this.validation_errors.push("A zone is missing it's ZoneName");
                return;
            }            
            if (!zone.container) {
                this.validation = false;
                this.validation_errors.push(zone.name + " is missing it's container");
                return;
            }
        });
    }

    __getAdsData = function () {
        //this is filled in __handleMappedZones
        return this.adsData;
    }

    __httpBuildQuery = function (obj) {
        const queryParams = new URLSearchParams();
        Object.entries(obj).forEach(([key, value]) => {
            if (typeof value === 'object' && value !== null) {
                const nestedValue = JSON.stringify(value);
                queryParams.append(key, nestedValue);
            } else {
                queryParams.append(key, value);
            }
        });
        return queryParams.toString();
    }

    __isEuTraffic = function () {
        let geo = this.__getAPIParams().data['geo'];
        return Object.keys(this.euTraffic).includes(this.country) || Object.values(this.euTraffic).includes(this.country);
    }

    __getAllowedDomains = function () {

        return (this.adsConfigs?.siteConfig?.allowedDomains ?? '').replace(' ', '').split(',');
    }

    __getDynamicInjectionRefreshAdZones = function () {
        let zones = {};
        //TODO in adsninja client (getRefreshData()) we check printAllAvailableAdHeadersOnInitialPage / pageNumber etc...
        for (let key in this.adsConfigs.dynamicInjectionRefreshAdZones) {
            let refreshZone = this.adsConfigs.dynamicInjectionRefreshAdZones[key];
            if (refreshZone.headerTemplate && refreshZone.contentTemplate && refreshZone.headerTemplate !== '' && refreshZone.contentTemplate !== '') {
                zones[key] = refreshZone;
            }
        }
        return zones;
    }

    __shouldIncludeCmp = function () {
        if (this.country && this.regionsToIncludeCMP.hasOwnProperty(this.country)) {
            if (Object.keys(this.regionsToIncludeCMP[this.country].states).length === 0 || (this.region && this.regionsToIncludeCMP[this.country].states.hasOwnProperty(this.region))) {
                return true
            }         
        }
        return false;
    }

    __getConsentContext = function () {
        if (this.__shouldIncludeCmp()) {
            return this.regionsToIncludeCMP[this.country].consentContext;
        }
        return null;
    }
    
    __getConsentNeeded = function () {
        if (this.__shouldIncludeCmp()) {
            return this.regionsToIncludeCMP[this.country].consentNeeded;
        }
        return false;
    }

    __addContentToHead = function (content) {
        if (!content) {
            return;
        }
        // Create a temporary container element to parse the string
        let tempContainer = document.createElement("div");
        tempContainer.innerHTML = content;
        // Add each element to the header
        Array.from(tempContainer.children).forEach((element) => {
            if (element.tagName === 'SCRIPT') {
                let script = document.createElement("script");
                script.innerHTML = element.innerHTML;
                if (element.getAttribute('src') !== undefined && element.getAttribute('src') !== null) {
                    script.src = element.getAttribute('src');
                }
                element = script;
            }
            document.head.appendChild(element);
        });
    }    
    
    __addContentToFooter = function (content) {
        if (!content) {
            return;
        }
        // Create a temporary container element to parse the string
        let tempContainer = document.createElement("div");
        tempContainer.innerHTML = content;
        // Add each element to the dooter
        Array.from(tempContainer.children).forEach((element) => {
            if (element.tagName === 'SCRIPT') {
                let script = document.createElement("script");
                script.innerHTML = element.innerHTML;
                if (element.getAttribute('src') !== undefined && element.getAttribute('src') !== null) {
                    script.src = element.getAttribute('src');
                }
                element = script;
            }
            document.body.appendChild(element);
        });
    }

    __waitForDOMReady = async function () {

        if(location.hostname.indexOf('hotcars.com') !== -1){

            return new Promise((resolve) => {
                if (document.readyState === "complete") {
                    resolve();
                } else {
                    document.addEventListener('readystatechange', function(event){
    
                        if('complete' === event.target.readyState){
                
                            resolve();
                        }
                    });
                }
            });
        }

        return new Promise((resolve) => {
            if (document.readyState !== "loading") {
                resolve();
            } else {
                document.addEventListener("DOMContentLoaded", resolve);
            }
        });
    }

    //
    // Determines the source of the traffic.
    __determineSource = function(){
        
        var referrer = document.referrer;

        if(referrer.indexOf('.google.') > -1){

            return 'organic';
        }
        else if(referrer.indexOf('.facebook.') > -1){

            return 'FB-P';
        }

        if(URLSearchParams){

            // Check URL params for utm_source.
            var params                    = new URLSearchParams(window.location.search);
            var universalTagManagerSource = params.get('utm_source');

            if(!universalTagManagerSource){

                return 'organic';
            }

            universalTagManagerSource = universalTagManagerSource.toLowerCase();

            if(universalTagManagerSource.indexOf('organic') > -1){

                return 'organic';
            }
            else if(universalTagManagerSource.indexOf('syndication') > -1){

                return 'syndication';
            }
            else if(universalTagManagerSource.indexOf('fb-') > -1 || universalTagManagerSource.indexOf('facebook') > -1){

                return 'FB-P';
            }
            else{

                // Balance.
                return 'balance';
            }
        }

        return 'organic';
    };
}

// TODO: Move this to a separate file.
window.adsNinja                = window.adsNinja || {};
window.adsNinja.queue          = window.adsNinja.queue || [];
window.adsNinja.storageManager = {
    get: function(key){

        if(!key || typeof key !== 'string') {

            throw new Error('Invalid key.');
        }

        return window.localStorage.getItem(key);
    },
    getWithExpiry: function(key){
        
        var itemString = this.get(key);

        if(!itemString){

            return null;
        }

        var item = JSON.parse(itemString);
        var now  = new Date();

        if(now.getTime() > item.expiry){

            this.remove(key);
            return null;
        }

        return item.value;
    },
    set: function(key, value){

        if(!key || !value || typeof key !== 'string' || typeof value !== 'string') {

            throw new Error('Invalid key or value.');
        }

        window.localStorage.setItem(key, value);
    },
    setWithExpiry: function(key, value, ttl){
        
        var now = new Date();

        var item = {
            value: value,
            expiry: now.getTime() + ttl,
        };

        this.set(key, JSON.stringify(item));
    },
    remove: function(key){
        
        window.localStorage.removeItem(key);
    },
    clear: function(){
        
        window.localStorage.clear();
    },
    getKeys: function(){
        
        return Object.keys(window.localStorage);
    },
    increment: function(key){
        
        var value = this.get(key);

        if(!value){

            value = 1;
        }
        else{
            
            value = parseInt(value) + 1;
        }

        this.set(key, value.toString());

        return value;
    },
    incrementWithExpiry: function(key, ttl){
        
        var value = this.getWithExpiry(key);

        if(!value){

            value = 1;
        }
        else{
            
            value = parseInt(value) + 1;
        }

        this.setWithExpiry(key, value.toString(), ttl);

        return value;
    },
    decrement: function(key){
        
        var value = this.get(key);

        if(!value){

            value = 1;
        }
        else{
            
            value = parseInt(value) - 1;
        }

        this.set(key, value.toString());

        return value;
    },
    decrementWithExpiry: function(key, ttl){
        
        var value = this.getWithExpiry(key);

        if(!value){

            value = 1;
        }
        else{
            
            value = parseInt(value) - 1;
        }

        this.setWithExpiry(key, value.toString(), ttl);

        return value;
    }
};

window.ads_injector = new AdsNinjaAdsInjector();

if (window.AdsInjectorConfig !== undefined) {
    window.ads_injector.setConfigs(window.AdsInjectorConfig);
    window.ads_injector.init();
}
